import { CustomDateRangeCalendar } from "@scmlatam/web-ui";
import type { useStepper } from "../hooks/useStepper";

const StepPeriod = (props: ReturnType<typeof useStepper>) => {
  const { range, setRange } = props;

  return (
    <>
      <CustomDateRangeCalendar
        initialValue={[null, null]}
        value={range}
        setValue={setRange}
        calendars={2}
        disabled={false}
        white
        autoCalendars
        centerCalendars
      />
    </>
  );
};

export { StepPeriod };
